import { Toolbar as RaToolbar, SaveButton } from "react-admin";

import BackButton from "../components/buttons/BackButton";
import React from "react";
import { useResourcePermissions } from "../usePermissions";
import { withStyles } from "@material-ui/core";

// const DefaultToolbar = (props) => (
//   <RaToolbar {...props}>
//     <SaveButton />
//     <BackButton href={`#/${props.resource}`} />
//   </RaToolbar>
// );

const DefaultToolbar = withStyles((theme) => ({
  toolbar: {
    "& button": {
      marginRight: theme.spacing.unit * 2,
    },
  },
}))(({ classes, ...props }) => {
  const { edit, create } = useResourcePermissions(props);
  let saveButton;

  if (props.resource === "sentinel") {
    // per vedere il save button basta avere il permesso sentile/edit perche le sentinelle
    // non possono proprio essere create
    saveButton = <SaveButton {...props} disabled={!edit} />;
  } else {
    saveButton = <SaveButton {...props} disabled={!edit || !create} />;
  }

  return (
    <RaToolbar {...props} classes={classes}>
      {saveButton}
      <BackButton href={`#/${props.resource}`} />
    </RaToolbar>
  );
});

export default DefaultToolbar;
